import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

function defaultState () {
  return {
    user: JSON.parse(sessionStorage.getItem('user')),
    isLoggedIn: false,
    theme: sessionStorage.getItem('theme') === 'dark',
    language: localStorage.getItem('language'),
    file: null,
    selectedSite: null,
    selectedScreen: null,
    pixabayImageURL: null,
    pixabayImageID: 0,
    mediaToEdit: null,
    editSuccessful: false,
    pixabayVideoURL: null,
    pixabayDuration: 0,
    uploadSuccessful: false,
    drawer: true
  }
}
const state = defaultState()
const mutations = {
  resetState (state) {
    let currentState = state
    let newState = {}
    let defaultValues = defaultState()
    Object.keys(defaultValues).forEach((key) => {
      newState[key] = defaultValues[key]
    })
    this.replaceState(newState)
  },
  setUser (state, user) {
    state.user = user
    sessionStorage.setItem('user', JSON.stringify(user))
  },
  setIsLoggedIn (state, isLoggedIn) {
    state.isLoggedIn = isLoggedIn
  },
  setTheme (state, theme) {
    state.theme = theme
    state.user.darkTheme = theme === 'dark'
  },
  setLanguage (state, language) {
    state.language = language
    localStorage.setItem('language', language)
    state.user.language = language
  },
  setFile (state, file) {
    state.file = file
  },
  setSelectedSite (state, selectedSite) {
    state.selectedSite = selectedSite
  },
  setSelectedScreen (state, selectedScreen) {
    state.selectedScreen = selectedScreen
  },
  setPixabayImageURL (state, pixabayImageURL) {
    state.pixabayImageURL = pixabayImageURL
  },
  setPixabayImageID (state, pixabayImageID) {
    state.pixabayImageID = pixabayImageID
  },
  setMediaToEdit (state, mediaToEdit) {
    state.mediaToEdit = mediaToEdit
  },
  setEditSuccessful(state, editSuccessful) {
    state.editSuccessful = editSuccessful
  },
  setUploadSuccessful (state, uploadSuccessful) {
    state.uploadSuccessful = uploadSuccessful
  },
  setPixabayVideoURL(state, pixabayVideoURL) {
    state.pixabayVideoURL = pixabayVideoURL
  },
  setPixabayDuration(state, pixabayDuration) {
    state.pixabayDuration = pixabayDuration
  },
  setIsDrawer(state, drawer) {
    state.drawer = drawer
  }
}
const actions =  {
  resetState({commit}) {
    commit('resetState', state)
  },
  setUser ({commit}, user) {
    commit('setUser', user)
  },
  setIsLoggedIn ({commit}, isLoggedIn) {
    commit('setIsLoggedIn', isLoggedIn)
  },
  setTheme ({commit}, theme) {
    commit('setTheme', theme)
  },
  setLanguage ({commit}, language) {
    commit('setLanguage', language)
  },
  setFile ({commit}, file) {
    commit('setFile', file)
  },
  setSelectedSite ({commit}, selectedSite) {
    commit('setSelectedSite', selectedSite)
  },
  setSelectedScreen ({commit}, selectedScreen) {
    commit('setSelectedScreen', selectedScreen)
  },
  setPixabayImageURL ({commit}, pixabayImageURL) {
    commit('setPixabayImageURL', pixabayImageURL)
  },
  setPixabayImageID ({commit}, pixabayImageID) {
    commit('setPixabayImageID', pixabayImageID)
  },
  setMediaToEdit ({commit}, mediaToEdit) {
    commit('setMediaToEdit', mediaToEdit)
  },
  setEditSuccessful ({commit}, editSuccessful) {
    commit('setEditSuccessful', editSuccessful)
  },
  setUploadSuccessful ({commit}, uploadSuccessful) {
    commit('setUploadSuccessful', uploadSuccessful)
  },
  setPixabayVideoURL({commit}, pixabayVideoURL) {
    commit('setPixabayVideoURL', pixabayVideoURL)
  },
  setPixabayDuration({commit}, pixabayDuration) {
    commit('setPixabayDuration', pixabayDuration)
  },
  setIsDrawer({commit}, drawer) {
    commit('setIsDrawer', drawer)
  }
}
export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters: {},
  strict: true,
  plugins: [createPersistedState({
    storage: window.sessionStorage,
  })]

})
